'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { transformExtendedQuery } from '@s7/styles';
import { COMPONENT_ID } from './MediaQuery.contract.js';
import { Box } from '../Box/Box.js';

var transformQueryToMedia = function(theme, _query, units) {
    var computedQuery = transformExtendedQuery(_query, units, false)(theme);
    if (computedQuery) {
        return computedQuery;
    }
    if (_query in theme.breakpoints) {
        return theme.fn.up(_query, units, true);
    }
    return _query;
};
var MediaQuery = function(param) {
    var query = param.query, styles = param.styles, children = param.children;
    return /*#__PURE__*/ jsx(Box, {
        sx: function(theme) {
            var _obj;
            return _obj = {}, _obj[transformQueryToMedia(theme, query)] = styles, _obj;
        },
        children: children
    });
};
var MediaQuery$1 = MediaQuery;
MediaQuery.displayName = COMPONENT_ID;

export { MediaQuery, MediaQuery$1 as default };
